import { Component, OnInit } from '@angular/core';
import { Service } from '../services';
import { GlobalService } from '../global.service';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AngularFireAnalytics } from '@angular/fire/analytics';
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.sass']
})
export class ProfileComponent implements OnInit {
  public accountData;
  public fullName;
  public celNum;
  public homeNumber;
  public selectBan;
  public email;
  public session: number;
  public AddressDet;
  public AddressDet2;
  public City;
  public Country;
  public State;
  public ZipCode;
  public type;

  public currentList;
  public postpago = false;
  public prepago = false;
  public telefoniaFijo = false;
  public totalAccountList;
  public token: string ='';


  constructor(
    public AngularFireAnalytics: AngularFireAnalytics,
    private services: Service, public global: GlobalService,
    private loadingScreenService: LoadingScreenService,
    private route: ActivatedRoute,
    private router: Router) {
    this.AngularFireAnalytics.setCurrentScreen("Mi Perfil");
    this.AngularFireAnalytics.logEvent("Mi Perfil-Screenview");
    router.events.subscribe((val: any) => {
      let count = 0
      if (count  == 0 && val.url) {
        count +=1
        this.getId();
      }
    });
  }
  public tabActive = 'Perfil';
  ngOnInit() {
    this.global.validateSession();
    this.token=sessionStorage.getItem("token");
    if (this.global.sessionReview() == true) {
      this.session = 1;
      this.getId();
      this.selectBan = atob(sessionStorage.getItem("selectBan"));
      this.getPersonalData(this.selectBan);
    }
  }
  initializeData() {
    this.global.refreshDataTo(this.token);
  }
  getId() {
    if (this.route.firstChild) {
      var id = this.route.firstChild.snapshot.params.id;
      if (id == '1') {
        this.session = 1;
      }
      else if (id == '2') {
        this.session = 2;
      }
      else if (id == '3') {
        this.session = 3;
      }
      else if (id == '4') {
        this.session = 4;
      }
      else if (id == '5') {
        this.session = 5;
      }
      else {
        this.session = 1;
        this.router.navigate(['profile']);
      }
    }
  }
  changeTab(idSession) {
    this.global.validateSession();
    this.session = idSession;
  }
  getPersonalData(account) {
    this.loadingScreenService.startLoading();
    this.services.getPersonalData(sessionStorage.getItem("token"), account).subscribe(data => {
      if (data.HasError == false) {
        this.loadingScreenService.stopLoading();
        sessionStorage.setItem("GetPersonalData", btoa(JSON.stringify(data)));
        this.accountData = JSON.parse(atob(sessionStorage.getItem("GetPersonalData")));
        if (this.accountData.BusinessName != null) {
          this.fullName = this.accountData.BusinessName;
        }
        else {
          this.fullName = this.accountData.FirstName + ' ' + this.accountData.LastName + ' ' + this.accountData.LastSecondName;
        }

        this.celNum = this.accountData.CelularPhone;
        if (this.celNum == '7870000000') {
          this.celNum = '';
        }
        this.homeNumber = this.accountData.PhoneNumber;
        this.email = this.accountData.Email;
        if (this.email == 'info@claropr.com') {
          this.email = '';
        }
        this.AddressDet = this.accountData.AddressDet;
        this.City = this.accountData.City;
        this.Country = this.accountData.Country;
        this.State = this.accountData.State;
        this.ZipCode = this.accountData.ZipCode;
        this.AddressDet2 = this.accountData.AddressDet2;
      }
      else {
        this.loadingScreenService.stopLoading();
        this.global.notif(data.ErrorDesc);
      }
    });
  }
}
